<tt-compare-flowchart
  ttColorCustomisations
  [compareMode]="isCompareMode()"
  [customisation]="organisationSettings().customisations?.flowchart"
  [editMode]="isEditMode()"
  [flowchartId]="widget()?.uniqueId"
  [local]="widget()?.localChanges?.elements"
  [mergeConflictStatus]="mergeConflictStatus()"
  [original]="widget()?.elements"
  (conflictResolved)="resolveMergeConflict.emit()"
  (conflictUnresolved)="unresolveMergeConflict.emit()"
  (exportFlowchartClicked)="handleExportFlowchartClicked($event)"
  (exportPdfFlowchartClicked)="handleExportPdfFlowchartClicked($event)"
  (localChanged)="handleLocalChanged($event)" />
